// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3gXBP","content":"ManualTimeModal_content__8SqEj"};